import * as React from "react";

//
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Footer from "../components/layout/Footer";
import Navbar from "../components/layout/Navbar";
import ProtectedRoute from "../components/ProtectedRoute";
import AllInsuarancMain from "../pages/allInsuarance/AllInsuarance.Main";
import BalanceMain from "../pages/balance/Balance.Main";
import FamilyTreeMain from "../pages/family_tree/Family_Tree.Main";
import HomeMain from "../pages/home/Home.Main";
import InvestPlanMain from "../pages/invest/InvestPlan.main";
import LegacyPlanMain from "../pages/legacy/Legacy.Main";
import FirstLogin from "../pages/login/Login.FirstLogin";
import LoginMain from "../pages/login/Login.Main";
import UsernameLoginPage from "../pages/login/username-login-page";
import ProfileMain from "../pages/profile/Profile.Main";
import ReportMain from "../pages/report/report.main";
import RetirePlanMain from "../pages/retirement_plan/Retirement_Plan.Main";
import SummaryTableFinance from "../pages/retirement_plan/Sum_TableFinance";
import ViewSummaryRetirePlan from "../pages/retirement_plan/components/VISummaryRetirePlan";
import RiskPlanMain from "../pages/risk_plan/Risk_Plan.Main";
import SavingPlanMain from "../pages/saving_plan/Saving_Plan.Main";
import TaxPlanMain from "../pages/tax_plan/Tax_Plan.Main";

import classNames from "classnames";
import _ from "lodash";
import { useBalanceStore } from "../_store/balanceStore";
import { useDebtStore } from "../_store/debtplanStore";
import { useEducationStore } from "../_store/educationStore";
import { useFamilyStore } from "../_store/familyStore";
import { useFamilytreeStore } from "../_store/familytreeStore";
import { useFuturePlanStore } from "../_store/futurePlanStore";
import { useInsuranceStore } from "../_store/insuranceStore";
import { useInvestStore } from "../_store/investStore";
import { useLegacyStore } from "../_store/legacyStore";
import { useLogOutTrigger } from "../_store/logoutTriggerStore";
import { useOpenStore } from "../_store/openStore";
import { useRetireStore } from "../_store/retireStore";
import { useRiskStore } from "../_store/riskStore";
import { useSavingStore } from "../_store/savingStore";
import { useStrategyStore } from "../_store/strategyRetireStore";
import { useTaxStore } from "../_store/taxplanStore";
import { useUserStore } from "../_store/userStore";
import Api from "../api/api.main";
import {
  sumCapitalInvest,
  sumDebtInvest,
} from "../functions/Balance/sumProperty";
import {
  SumDebtPersonalValue,
  SumOtherDebtAmount,
} from "../functions/Balance/sumValueBalance";
import { TabThreeWithHoldingTax } from "../functions/taxFucntion/premium/tab3function";
import TaxHeirachy from "../functions/taxFucntion/taxHeirachy";
import AboutusMain from "../pages/aboutus/AboutUs.Main";
import { numberWithoutComma } from "../pages/balance/component/VIDrawerDebt.Main";
import { key_property_invest_category } from "../pages/balance/functions";
import {
  sumIncome,
  SumtotalInvestEducation,
} from "../pages/balance/functions/forPutData";
import DebtMain from "../pages/debt/Debt.Main";
import ViewDebtPlanForm from "../pages/debt/component/VIDebtPlanForm";
import EducationMain from "../pages/education/Education.Main";
import ViewEduInfo from "../pages/education/components/ViewEduInfo.Main";
import FutureMain from "../pages/future_plan/Future.Main";
import InsuarancePlanMain from "../pages/insuarance_plan/InsuarancePlan.Main";
import ViewDisableInsurance from "../pages/insuarance_plan/component/VIDisable_Insurance";
import ViewFamilyInsurance from "../pages/insuarance_plan/component/VIFamily_Insurance";
import ViManualFormOne from "../pages/legacy/components/VI.ManualFormOne";
import ViManualFormThree from "../pages/legacy/components/VI.ManualFormThree";
import ViManualFormTwo from "../pages/legacy/components/VI.ManualFormTwo";
import ViNormalFormOne from "../pages/legacy/components/VI.NormalOne";
import ViNormalFormThree from "../pages/legacy/components/VI.NormalThree";
import ViNormalFormTwo from "../pages/legacy/components/VI.NormalTwo";
import PDFMain from "../pages/pdf/pdf.main";
import ReportAllInsurancePage from "../pages/report/view/report.v.allInsurance";
import ReportAssetPage from "../pages/report/view/report.v.asset";
import ReportBalancePage from "../pages/report/view/report.v.balance";
import ReportDebtPage from "../pages/report/view/report.v.debt";
import ReportDebtPlanPage from "../pages/report/view/report.v.debtplan";
import ReportDisableInsurancePage from "../pages/report/view/report.v.disableInsurance";
import ReportEducationPage from "../pages/report/view/report.v.education";
import ReportExpensePage from "../pages/report/view/report.v.expense";
import ReportFamilyInsurancePage from "../pages/report/view/report.v.familyInsurance";
import ReportFinancialPage from "../pages/report/view/report.v.financial";
import ReportFuturePlanPage from "../pages/report/view/report.v.futureplan";
import ReportHeritagePage from "../pages/report/view/report.v.heritage";
import ReportHypothesisPage from "../pages/report/view/report.v.hypothesis";
import ReportIncomePage from "../pages/report/view/report.v.income";
import ReportInvestPage from "../pages/report/view/report.v.invest";
import ReacteportOverViewPage from "../pages/report/view/report.v.overview";
import ReportRetirePage from "../pages/report/view/report.v.retire";
import ReportRiskPage from "../pages/report/view/report.v.risk";
import ReportSavingPage from "../pages/report/view/report.v.saving";
import ReportTaxPage from "../pages/report/view/report.v.tax";
import ViewSensitiveTest from "../pages/retirement_plan/components/VISensitiveTest";
import ViewIncomeFreelance from "../pages/tax_plan/components/Premium/VIIncome_Freelance";
import ViewIncomeHeritage from "../pages/tax_plan/components/Premium/VIIncome_Heritage";
import ViewIncomeInvest from "../pages/tax_plan/components/Premium/VIIncome_Invest";
import ViewIncomeSalaryPremium from "../pages/tax_plan/components/Premium/VIIncome_Salary.Premium";
import ViInfoTaxProfile from "../pages/tax_plan/components/Premium/VIInfoTaxProfile.Main";
import ViewIncomeBusiness from "../pages/tax_plan/components/Premium/VIincome_Business";
import {
  checkFullRight,
  cheskIsPlanTax,
} from "../pages/tax_plan/functions/firstLoad";
import { toFloat2 } from "../utils/useFunctions";
import api from "../api/api.main";
import PremiumInfo from "../pages/premiumInfo/premiuminfo";
import PaymentComplete from "../pages/paymentcomplete/paymentcomplete";
import NotFoundPage from "../components/not-found/not-found-page";
const { DateTime } = require("luxon");

export const updateStorage = async ({
  userData,
  balanceData,
  pathname,
  investData,
  educationData,
  taxData,
  strategy,
  retireData,
  savingData,
  riskData,
  insuranceData,
  familyData,
  openData,
  familytreeData,
  debtData,
  futurePlanData,
  legacyData,
}) => {
  const addInvest = balanceData?.property_invest_list
    ? balanceData?.property_invest_list
    : [];
  const ReturnInsurance = () => {
    let tempBalance = balanceData;
    if (tempBalance) {
      let tempInsuranceReturn = tempBalance?.expenses_fixed_list
        ?.filter(
          (item) => item.options_expenses_fixed === "expenses_insuarant_life"
        )
        ?.map((item) => item.expenses_insuarant_lifes)
        .flat();

      let tempBalanceData = {};
      //=============เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)=============//

      if (
        tempBalance?.property_invest_list
          ?.map((item) => item.options_property_invest_title)
          .includes("เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)") &&
        tempInsuranceReturn?.length === 0
      ) {
        // ถ้ามีหัวข้อนี้อยู่แล้ว
        let tempNameList = tempBalance?.property_invest_list
          .find(
            (item) =>
              item?.options_property_invest_title ===
              "เงินลงทุนอื่น ๆ (สินทรัพย์ทางเลือก)"
          )
          ?.invest_other_lists?.filter((item) => item !== null)
          ?.map((item) => item?.title);

        let tempInvestList = tempBalance?.property_invest_list?.map((item) => {
          if (item?.invest_other_lists) {
            let tempData = tempInsuranceReturn
              ?.map((item2) => {
                if (!tempNameList?.includes(item2.title))
                  return {
                    amount: item2?.more_details?.policy_surrender_value,
                    created: item2.created,
                    reward_amount_per_year: item?.reward_amount_per_year || 1,
                    target_invest: {},
                    title: item2.title,
                    editable: false,
                  };
              })
              .filter((item) => item !== undefined);
            return {
              ...item,
              invest_other_lists: [...item.invest_other_lists, ...tempData],
            };
          }
          return item;
        });

        tempBalanceData = tempInvestList;
      } else {
        // ถ้ายังไม่มีหัวข้อนี้อยู่
        let tempInvestList = tempInsuranceReturn?.map((item) => {
          return {
            amount: item?.more_details?.policy_surrender_value,
            created: item.created,
            reward_amount_per_year: item?.reward_amount_per_year || 1,
            target_invest: item?.target_invest || {},
            title: item.title,
            editable: true,
          };
        });

        tempBalanceData = tempInvestList;
      }
      return;
    }
  };

  try {
    if (!userData || ["/report", "/pdf"].includes(pathname)) return;

    let injectBalanceData = { ...balanceData };
    let injectinvestData = { ...investData };

    // จำนวนประกันบ้าน
    let count_expenses_insuarant_fires =
      balanceData?.expenses_fixed_list
        ?.filter(
          (item) => item?.options_expenses_fixed === "expenses_insuarant_fire"
        )
        ?.map((item) => item?.expenses_insuarant_fires)
        .flat()?.length || 0;

    // จำนวนบ้านเป็นหนี้
    let count_property_debt_lists =
      balanceData?.debt_long_list
        ?.filter((item) => item?.options_debt_long === "debt_place")
        ?.map((item) => item?.home_lists)
        .flat()?.length || 0;

    // จำนวนบ้านไม่เป็นหนี้
    let count_property_private_home_lists =
      balanceData?.property_private_list
        ?.filter(
          (item) => item?.options_property_private_title === "บ้านที่อยู่อาศัย"
        )
        ?.map((item) => item?.home_lists)
        .flat()?.length || 0;

    // console.log("balanceData?.property_private_list",balanceData?.property_private_list)
    // console.log("count_property_private_home_lists",count_property_private_home_lists)
    // console.log("count_property_debt_lists", count_property_debt_lists);

    injectBalanceData.count_expenses_insuarant_fires = Number(
      count_expenses_insuarant_fires
    );
    injectBalanceData.count_property_private_home_lists = Number(
      count_property_private_home_lists + count_property_debt_lists
    );

    //================================================================================================

    // จำนวนประกันรถ
    let count_expenses_insuarant_cars = _.size(
      _.flatMap(balanceData?.expenses_fixed_list, "expenses_insuarant_cars")
    );
    let count_property_private_car_lists = _.size(
      balanceData?.property_private_list
        ?.filter((item) => item?.options_property_private_title === "รถยนต์")
        ?.map((item) => item?.car_lists)
        .flat()
    );

    count_property_private_car_lists += _.size(
      balanceData?.debt_long_list
        ?.filter((item) => item?.options_debt_long === "debt_car")
        ?.map((item) => item?.debt_long_cars)
        .flat()
    );

    let expenses_insuarant_lifes_detail_sum = _.flatMap(
      balanceData?.expenses_fixed_list,
      "expenses_insuarant_lifes"
    )?.reduce((acc, num) => {
      return (
        acc +
        Number(num?.more_details?.compensation_aia_ci_plus || 0) +
        Number(num?.more_details?.compensation_aia_ci_plus_gold || 0) +
        Number(num?.more_details?.compensation_aia_supercare || 0) +
        Number(num?.more_details?.compensation_ecir || 0) +
        Number(num?.more_details?.compensation_mutiple_care_ci || 0) +
        Number(num?.more_details?.critical_illness_insurance_yearly_ci || 0)
      );
    }, 0);

    // console.log("expenses_insuarant_lifes_detail_sum",expenses_insuarant_lifes_detail_sum)

    let expenses_insuarant_lifes_health_sum = _.flatMap(
      balanceData?.expenses_fixed_list,
      "expenses_insuarant_lifes"
    )?.reduce((acc, num) => {
      return (
        acc +
        Number(
          numberWithoutComma(num?.more_details?.hospital_treatment_surgery) || 0
        ) +
        Number(
          numberWithoutComma(
            num?.more_details?.hospital_treatment_surgery_lump_sum_payment
          ) || 0
        )
      );
    }, 0);

    //  อัตราส่วนหนี้ต่อสินทรัพย์
    let debtToAssetRatio = 0;

    let sumAsset =
      Number(balanceData?.sum_property_asset || 0) +
      SumDebtPersonalValue(balanceData) +
      sumCapitalInvest(addInvest, ReturnInsurance()) +
      sumDebtInvest(balanceData) +
      Number(balanceData?.sum_property_private || 0) +
      SumOtherDebtAmount(balanceData) +
      Number(balanceData?.sum_property_intangible || 0);

    if (balanceData?.debt_propotion) {
      debtToAssetRatio =
        sumAsset > 0 ? (balanceData?.debt_propotion / sumAsset) * 100 : 0;
    }

    injectBalanceData.debtToAssetRatio = debtToAssetRatio;
    //================================================================================================

    // แผนลงทุน

    let is_Equity_Instruments_advice = false;
    let is_Debt_Instruments_advice = false;
    let is_Alternaitve_Investments_advice = false;

    let Equity_Instruments_Value_advice = 0;
    let Debt_Instruments_Value_advice = 0;
    let Alternaitve_Investments_Value_advice = 0;

    if (investData?.sum_score < 15) {
      is_Equity_Instruments_advice = true;
      is_Debt_Instruments_advice = true;
      is_Alternaitve_Investments_advice = false;

      Equity_Instruments_Value_advice = 20;
      Debt_Instruments_Value_advice = 80;
      Alternaitve_Investments_Value_advice = 0;
    } else if (investData?.sum_score > 15 && investData?.sum_score < 21) {
      is_Equity_Instruments_advice = true;
      is_Debt_Instruments_advice = true;
      is_Alternaitve_Investments_advice = false;

      Equity_Instruments_Value_advice = 30;
      Debt_Instruments_Value_advice = 70;
      Alternaitve_Investments_Value_advice = 0;
    } else if (investData?.sum_score > 22 && investData?.sum_score < 29) {
      is_Equity_Instruments_advice = true;
      is_Debt_Instruments_advice = true;
      is_Alternaitve_Investments_advice = true;

      Equity_Instruments_Value_advice = 30;
      Debt_Instruments_Value_advice = 60;
      Alternaitve_Investments_Value_advice = 10;
    } else if (investData?.sum_score > 30 && investData?.sum_score < 36) {
      is_Equity_Instruments_advice = true;
      is_Debt_Instruments_advice = true;
      is_Alternaitve_Investments_advice = true;

      Equity_Instruments_Value_advice = 40;
      Debt_Instruments_Value_advice = 40;
      Alternaitve_Investments_Value_advice = 20;
    } else {
      is_Equity_Instruments_advice = true;
      is_Debt_Instruments_advice = false;
      is_Alternaitve_Investments_advice = true;

      Equity_Instruments_Value_advice = 80;
      Debt_Instruments_Value_advice = 0;
      Alternaitve_Investments_Value_advice = 20;
    }

    injectinvestData.is_Equity_Instruments_advice =
      is_Equity_Instruments_advice;
    injectinvestData.is_Debt_Instruments_advice = is_Debt_Instruments_advice;
    injectinvestData.Equity_Instruments_Value_advice =
      Equity_Instruments_Value_advice;
    injectinvestData.Debt_Instruments_Value_advice =
      Debt_Instruments_Value_advice;
    injectinvestData.is_Alternaitve_Investments_advice =
      is_Alternaitve_Investments_advice;
    injectinvestData.Alternaitve_Investments_Value_advice =
      Alternaitve_Investments_Value_advice;

    const makeInvestmentRatio = () => {
      if (!balanceData?.property_invest_list?.length) {
        return [];
      }

      const filterPropertyInvest = balanceData.property_invest_list.filter(
        (item) => item?.options_property_invest_category
      );

      const groupInvest = _.groupBy(
        filterPropertyInvest,
        "options_property_invest_category"
      );

      const convertGroupInvest = Object.keys(groupInvest)?.map((key) => {
        const amount = groupInvest[key]?.reduce((prev, curr) => {
          const itemKeys = Object.keys(curr);
          for (const itemKey of itemKeys) {
            const itemValue = curr[itemKey];
            if (_.isArray(itemValue)) {
              return (
                prev + itemValue?.reduce((prev, curr) => prev + curr.amount, 0)
              );
            }
          }
        }, 0);

        return {
          key,
          label: key_property_invest_category[key],
          value: amount,
          amount,
        };
      });

      const newItems = [];
      const total = convertGroupInvest?.reduce(
        (prev, curr) => prev + curr.value,
        0
      );

      for (const convertGroupInvestItem of convertGroupInvest) {
        const createItem = {
          label: convertGroupInvestItem.label,
          value: (convertGroupInvestItem.value / total) * 100,
          amount: convertGroupInvestItem.amount,
        };
        newItems.push(createItem);
      }

      // clean data
      const cleanItems = newItems?.map((item) => {
        return {
          label: item.label,
          value: toFloat2(item.value),
          amount: item.amount,
        };
      });

      const sortItems = [
        {
          label: "ตราสารทุน",
        },
        {
          label: "ตราสารหนี้",
        },
        {
          label: "เงินฝาก",
        },
        {
          label: "สินทรัพย์ทางเลือก",
        },
      ];

      const sortItemsMap = sortItems
        ?.map((sortItem) => {
          const findItem = cleanItems.find(
            (item) => item.label === sortItem.label
          );
          return findItem;
        })
        .filter((item) => item !== undefined);

      return sortItemsMap;
    };

    let is_Equity_Instruments_current = false;
    let is_Debt_Instruments_current = false;
    let is_Alternaitve_Investments_current = false;

    let Equity_Instruments_Value_current = 0;
    let Debt_Instruments_Value_current = 0;
    let Alternaitve_Investments_Value_current = 0;

    makeInvestmentRatio()?.map((item, index) => {
      if (item.label === "ตราสารทุน") {
        is_Equity_Instruments_current = true;
        Equity_Instruments_Value_current = item.value;
      } else if (item.label === "ตราสารหนี้") {
        is_Debt_Instruments_current = true;
        Debt_Instruments_Value_current = item.value;
      } else if (item.label === "สินทรัพย์ทางเลือก") {
        is_Alternaitve_Investments_current = true;
        Alternaitve_Investments_Value_current = item.value;
      }
    });

    injectinvestData.is_Equity_Instruments_current =
      is_Equity_Instruments_current;
    injectinvestData.is_Debt_Instruments_current = is_Debt_Instruments_current;
    injectinvestData.is_Alternaitve_Investments_current =
      is_Alternaitve_Investments_current;

    injectinvestData.Equity_Instruments_Value_current =
      Equity_Instruments_Value_current;
    injectinvestData.Debt_Instruments_Value_current =
      Debt_Instruments_Value_current;
    injectinvestData.Alternaitve_Investments_Value_current =
      Alternaitve_Investments_Value_current;

    //================================================================================================

    injectBalanceData.count_expenses_insuarant_cars =
      count_expenses_insuarant_cars;
    injectBalanceData.count_property_private_car_lists =
      count_property_private_car_lists;

    injectBalanceData.expenses_insuarant_lifes_detail_sum =
      expenses_insuarant_lifes_detail_sum;

    injectBalanceData.expenses_insuarant_lifes_health_sum =
      expenses_insuarant_lifes_health_sum;

    // แผนการศึกษาบุตร

    let userDataInject = { ...userData };
    let sum_every_education = 0;
    let sum_every_education_invest = 0;

    sum_every_education = educationData?.reduce((total, num) => {
      return total + num.sum_total_education;
    }, 0);

    sum_every_education_invest = SumtotalInvestEducation(balanceData);

    userDataInject.sum_every_education = sum_every_education;
    userDataInject.sum_every_education_invest = sum_every_education_invest;

    //================================================================================================

    //แผนภาษี
    // sumIncome
    let taxDataInject = { ...taxData };
    let sum_total_income = sumIncome(taxData) || 0;
    let sum_total_withholding = TabThreeWithHoldingTax(taxData) || 0;

    // TaxHeirachy(form, () => {}, "four")
    let tax_Heirachy_Final_lists = TaxHeirachy(taxData, () => {}, "four");

    let is_deduction_full_right = checkFullRight(taxData);

    let is_use_all_deduction = cheskIsPlanTax(taxData);

    taxDataInject.sum_total_income = sum_total_income;
    taxDataInject.sum_total_withholding = sum_total_withholding;
    taxDataInject.tax_Heirachy_Final_lists = tax_Heirachy_Final_lists;
    taxDataInject.is_deduction_full_right = is_deduction_full_right;
    taxDataInject.is_use_all_deduction = is_use_all_deduction;

    //================================================================================================

    // แผนอนาคต
    let futurePlanDataInject = { ...futurePlanData };

    // Safely handle undefined or null values in cash_flow_items
    const moneyNeed = () => {
      if (
        !futurePlanData?.cash_flow_items ||
        !Array.isArray(futurePlanData.cash_flow_items)
      ) {
        return [];
      }

      const findData = futurePlanData.cash_flow_items.filter((item) => {
        return item?.remain_accumulate < 0 && item?.remain < 0;
      });

      return findData;
    };

    futurePlanDataInject.moneyNeed = moneyNeed();

    //=============================================
    const { data: dataStorage } = await Api.get(
      `/storages/profile/${userData._id}`
    );
    if (!dataStorage?.storage) {
      await Api.post(`/storages`, {
        profileId: userDataInject._id,
        userData: userDataInject,
        strategy,
        retireData,
        taxData: taxDataInject,
        savingData,
        balanceData: injectBalanceData,
        riskData,
        educationData,
        insuranceData,
        familyData,
        openData,
        familytreeData,
        debtData,
        futurePlanData,
        investData: injectinvestData,
        legacyData,
      });
    } else {
      let educationDataLists = educationData?.map((item) => {
        return {
          ...item,
        };
      });

      await Api.put(`/storages/${dataStorage.storage._id}`, {
        balanceData: injectBalanceData,
        profileId: userDataInject._id,
        userData: userDataInject,
        taxData: taxDataInject,
        riskData,
        educationData: educationDataLists,
        insuranceData,
        retireData,
        familyData,
        openData,
        familytreeData,
        savingData,
        debtData,
        strategy,
        futurePlanData: { ...futurePlanDataInject },
        // futurePlanData,
        investData: injectinvestData,
        legacyData,
      });
    }
  } catch (error) {
    console.log("update storage error", error);
  }
};

const MainRouter = () => {
  const strategy = useStrategyStore((state) => state.strategy);
  const retireData = useRetireStore((state) => state.retireData);
  const taxData = useTaxStore((state) => state.taxData);
  const savingData = useSavingStore((state) => state.savingData);
  const userData = useUserStore((state) => state.userData);
  const balanceData = useBalanceStore((state) => state.balanceData);
  const riskData = useRiskStore((state) => state.riskData);
  const educationData = useEducationStore((state) => state.educationData);
  const insuranceData = useInsuranceStore((state) => state.insuranceData);
  const familyData = useFamilyStore((state) => state);
  const openData = useOpenStore((state) => state);
  const familytreeData = useFamilytreeStore((state) => state.familytreeData);
  const debtData = useDebtStore((state) => state.debtData);
  const investData = useInvestStore((state) => state.investData);
  const futurePlanData = useFuturePlanStore((state) => state.futurePlanData);
  const legacyData = useLegacyStore((state) => state.legacyData);

  const logOutTrigger = useLogOutTrigger((state) => state.logOutTrigger);

  const [trigger, setTrigger] = React.useState(false);
  const pathname = useLocation().pathname;

  const navigate = useNavigate();

  React.useEffect(() => {
    if (
      window?.location.hostname === "https://assurewealth.website/" ||
      window?.location.hostname === "assurewealth.website" ||
      window?.location.hostname === "https://www.assurewealth.website" ||
      window?.location.hostname === "www.assurewealth.website"
    ) {
      window.location.href = "https://assurewealthonline.com/";
    }
  }, []);

  React.useEffect(() => {
    const createTimer = setInterval(() => {
      setTrigger(!trigger);
    }, 1000 * 15);

    return () => {
      clearInterval(createTimer);
    };
  }, [trigger]);

  React.useEffect(() => {
    updateStorage({
      strategy,
      retireData,
      taxData,
      savingData,
      userData,
      balanceData,
      riskData,
      educationData,
      insuranceData,
      familyData,
      openData,
      familytreeData,
      debtData,
      futurePlanData,
      investData,
      legacyData,
      pathname,
    });
  }, [trigger, logOutTrigger]);

  React.useEffect(() => {
    const NotPremium = async () => {
      try {
        await api.put(`/profiles/${userData?._id}`, {
          first_Premium: false,
          is_premium: false,
          is_premium_done: true,
          referral_code: "",
        });
        localStorage.clear();
        window.location.reload();
        navigate("/login");

        return;
      } catch (error) {
        console.log("error in NotPremium", error);
      }
    };

    if (!userData?._id) {
      return;
    }

    if (
      userData?.is_premium &&
      userData?.first_Premium &&
      DateTime.now().ts > DateTime.fromISO(userData?.premium_expired).ts
    ) {
      NotPremium();
      return;
    }

    if (
      userData?.is_premium &&
      DateTime.now().ts > DateTime.fromISO(userData?.premium_expired).ts
    ) {
      NotPremium();
      return;
    }
    return;
  }, [trigger]);


  return (
    <React.Fragment>
      <div
        style={{
          backgroundImage:
            window?.location?.pathname === "/" ||
            window?.location?.pathname === "/profile"
              ? ""
              : "url(/images/circle.png)",
          backgroundRepeat: "no-repeat",
          backgroundPosition:
            window?.location?.pathname === "/" ||
            window?.location?.pathname === "/profile"
              ? ""
              : "left",
        }}
        className={classNames(
          " font-IBMPlexSansThai flex flex-col justify-between relative min-h-screen mx-auto  ",
          {
            "max-w-2xl": window?.location?.pathname !== "/pdf",
          }
        )}
      >
        <div>
          <Navbar />
          <Routes>
            <Route path="/login" element={<LoginMain />} />
            <Route path="/login/username" element={<UsernameLoginPage />} />
            <Route path="/firstlogin" element={<FirstLogin />} />
            {/* รู้จักเรา */}
            <Route path="/aboutus" element={<AboutusMain />} />
            {/* ภาษี */}
            <Route path="/" element={<HomeMain />} />
            <Route path="/infopremium" element={<PremiumInfo />} />

            {/* Protected Routes */}
            <Route
              path="/familytree"
              element={
                // <ProtectedRoute>
                //   <FamilyTreeMain />
                // </ProtectedRoute>
                <FamilyTreeMain />
              }
            />
            <Route
              path="/allInsuarance"
              element={
                <ProtectedRoute>
                  <AllInsuarancMain />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <ProfileMain />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pdf"
              element={
                <ProtectedRoute>
                  <PDFMain />
                </ProtectedRoute>
              }
            />
            <Route
              path="/taxplan"
              element={
                <TaxPlanMain />
                // <ProtectedRoute>
                //   <TaxPlanMain />
                // </ProtectedRoute>
              }
            />
            {/* <Route path="/taxplan" element={<ViewStepOnePremium />} /> */}

            {/* ViewStepOnePremium */}
            <Route
              path="/taxpayerInfo"
              element={
                <ProtectedRoute>
                  <ViInfoTaxProfile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/taxIncomeSalary"
              element={
                <ProtectedRoute>
                  <ViewIncomeSalaryPremium />
                </ProtectedRoute>
              }
            />
            <Route
              path="/taxIncomeFreelance"
              element={
                <ProtectedRoute>
                  <ViewIncomeFreelance />
                </ProtectedRoute>
              }
            />
            <Route
              path="/taxIncomeBusiness"
              element={
                <ProtectedRoute>
                  <ViewIncomeBusiness />
                </ProtectedRoute>
              }
            />
            <Route
              path="/taxIncomeInvest"
              element={
                <ProtectedRoute>
                  <ViewIncomeInvest />
                </ProtectedRoute>
              }
            />
            <Route
              path="/taxIncomeHeritage"
              element={
                <ProtectedRoute>
                  <ViewIncomeHeritage />
                </ProtectedRoute>
              }
            />
            {/* เกษียณ */}
            <Route
              path="/retireplan"
              element={
                <RetirePlanMain />
              }
            />
            <Route
              path="/summaryresult"
              element={
                <ViewSummaryRetirePlan />
              }
            />
            <Route
              path="/sensitivetest"
              element={
                <ViewSensitiveTest />

                // <ProtectedRoute>
                //   <ViewSensitiveTest />
                // </ProtectedRoute>
              }
            />
            {/* <Route path="/summarytax" element={<ViewSummaryTaxPlan />} /> */}
            <Route
              path="/summarytablemovements"
              element={
                <SummaryTableFinance />

                // <ProtectedRoute>
                //   <SummaryTableFinance />
                // </ProtectedRoute>
              }
            />
            {/* งมดุล */}
            <Route
              path="/balance"
              element={
                <ProtectedRoute>
                  <BalanceMain />
                </ProtectedRoute>
              }
            />
            {/* ความเสี่ยง */}
            <Route
              path="/riskplan"
              element={
                <ProtectedRoute>
                  <RiskPlanMain />
                </ProtectedRoute>
              }
            />

            {/* มรดก */}
            <Route
              path="/legacyplan"
              element={
                <ProtectedRoute>
                  <LegacyPlanMain />
                </ProtectedRoute>
              }
            />
            {/* มรดกแบบเขียนเอง 1 */}
            <Route
              path="/legacy/manualformone"
              element={
                <ProtectedRoute>
                  <ViManualFormOne />
                </ProtectedRoute>
              }
            />
            {/* มรดกแบบเขียนเอง 2 */}
            <Route
              path="/legacy/manualformtwo"
              element={
                <ProtectedRoute>
                  <ViManualFormTwo />
                </ProtectedRoute>
              }
            />
            {/* มรดกแบบเขียนเอง 3 */}
            <Route
              path="/legacy/manualformthree"
              element={
                <ProtectedRoute>
                  <ViManualFormThree />
                </ProtectedRoute>
              }
            />
            {/* มรดกแบบธรรมดา 1  */}
            <Route
              path="/legacy/normalformone"
              element={
                <ProtectedRoute>
                  <ViNormalFormOne />
                </ProtectedRoute>
              }
            />
            {/* มรดกแบบธรรมดา 2 */}
            <Route
              path="/legacy/normalformtwo"
              element={
                <ProtectedRoute>
                  <ViNormalFormTwo />
                </ProtectedRoute>
              }
            />
            {/* มรดกแบบธรรมดา 3 */}
            <Route
              path="/legacy/normalformthree"
              element={
                <ProtectedRoute>
                  <ViNormalFormThree />
                </ProtectedRoute>
              }
            />

            {/* ออม */}
            <Route
              path="/savingsplan"
              element={
                <SavingPlanMain />
                // <ProtectedRoute>
                //   <SavingPlanMain />
                // </ProtectedRoute>
              }
            />
            {/* ลงทุน */}
            <Route
              path="/investplan"
              element={
                <ProtectedRoute>
                  <InvestPlanMain />
                </ProtectedRoute>
              }
            />
            {/* การศึกษาบุตร */}
            <Route
              path="/education"
              element={
                <ProtectedRoute>
                  <EducationMain />
                </ProtectedRoute>
              }
            />
            <Route
              path="/education/info"
              element={
                <ProtectedRoute>
                  <ViewEduInfo />
                </ProtectedRoute>
              }
            />
            {/* จัดการหนี้สิน */}
            <Route
              path="/debtplan"
              element={
                <ProtectedRoute>
                  <DebtMain />
                </ProtectedRoute>
              }
            />
            <Route
              path="/debtplan/form"
              element={
                <ProtectedRoute>
                  <ViewDebtPlanForm />
                </ProtectedRoute>
              }
            />
            {/* แผนประกัน */}
            <Route
              path="/insuranceplan"
              element={
                <ProtectedRoute>
                  <InsuarancePlanMain />
                </ProtectedRoute>
              }
            />
            <Route
              path="/insuranceplan/family"
              element={
                <ProtectedRoute>
                  <ViewFamilyInsurance />
                </ProtectedRoute>
              }
            />
            <Route
              path="/insuranceplan/disabled"
              element={
                <ProtectedRoute>
                  <ViewDisableInsurance />
                </ProtectedRoute>
              }
            />
            {/* แผนอนาคต  */}
            <Route
              path="/futureplan"
              element={
                <ProtectedRoute>
                  <FutureMain />
                </ProtectedRoute>
              }
            />
            {/* รายงาน */}
            <Route
              path="/report"
              element={
                <ProtectedRoute>
                  <ReportMain />
                </ProtectedRoute>
              }
            />
            {/* รายงานภาพรวม */}
            <Route
              path="/report/overview"
              element={
                <ProtectedRoute>
                  <ReacteportOverViewPage />
                </ProtectedRoute>
              }
            />
            {/* รายงานสมมติฐาน */}
            <Route
              path="/report/hypothesis"
              element={
                <ProtectedRoute>
                  <ReportHypothesisPage />
                </ProtectedRoute>
              }
            />
            {/* รายงานรายรับ */}
            <Route
              path="/report/income"
              element={
                <ProtectedRoute>
                  <ReportIncomePage />
                </ProtectedRoute>
              }
            />
            {/* รายงานหนี้สิน */}
            <Route
              path="/report/debt"
              element={
                <ProtectedRoute>
                  <ReportDebtPage />
                </ProtectedRoute>
              }
            />
            {/* รายงานรายจ่าย */}
            <Route
              path="/report/expense"
              element={
                <ProtectedRoute>
                  <ReportExpensePage />
                </ProtectedRoute>
              }
            />
            {/* รายงานสินทรัพย์ */}
            <Route
              path="/report/asset"
              element={
                <ProtectedRoute>
                  <ReportAssetPage />
                </ProtectedRoute>
              }
            />
            {/* รายงานงบดุล */}
            <Route
              path="/report/balance"
              element={
                <ProtectedRoute>
                  <ReportBalancePage />
                </ProtectedRoute>
              }
            />
            {/* รายงานอัตราส่วนการเงิน */}
            <Route
              path="/report/financial"
              element={
                <ProtectedRoute>
                  <ReportFinancialPage />
                </ProtectedRoute>
              }
            />
            {/* รายงานบริหารความเสี่ยง */}
            <Route
              path="/report/riskplan"
              element={
                <ProtectedRoute>
                  <ReportRiskPage />
                </ProtectedRoute>
              }
            />
            {/* รายงานสัดส่วนการลงทุน */}
            <Route
              path="/report/investment"
              element={
                <ProtectedRoute>
                  <ReportInvestPage />
                </ProtectedRoute>
              }
            />
            {/* รายงานแผนเกษียณ */}
            <Route
              path="/report/retirement"
              element={
                <ProtectedRoute>
                  <ReportRetirePage />
                </ProtectedRoute>
              }
            />
            {/* รายงานภาษี */}
            <Route
              path="/report/tax"
              element={
                <ProtectedRoute>
                  <ReportTaxPage />
                </ProtectedRoute>
              }
            />
            {/* รายงานทุพพลภาพ */}
            <Route
              path="/report/disableInsurance"
              element={
                <ProtectedRoute>
                  <ReportDisableInsurancePage />
                </ProtectedRoute>
              }
            />
            {/* รายงานทุนแผนประกันครอบครัว */}
            <Route
              path="/report/familyInsurance"
              element={
                <ProtectedRoute>
                  <ReportFamilyInsurancePage />
                </ProtectedRoute>
              }
            />

            {/* รายงานการศึกษาบุตร */}
            <Route
              path="/report/education"
              element={
                <ProtectedRoute>
                  <ReportEducationPage />
                </ProtectedRoute>
              }
            />
            {/* รายงานแผนอนาคต */}
            <Route
              path="/report/futureplan"
              element={
                <ProtectedRoute>
                  <ReportFuturePlanPage />
                </ProtectedRoute>
              }
            />
            {/* รายงานวางแผนหนี้สิน */}
            <Route
              path="/report/debtplan"
              element={
                <ProtectedRoute>
                  <ReportDebtPlanPage />
                </ProtectedRoute>
              }
            />

            {/* รายงานแผนมรดก */}
            <Route
              path="/report/heritage"
              element={
                <ProtectedRoute>
                  <ReportHeritagePage />
                </ProtectedRoute>
              }
            />
            {/* รายงานรวมแผนประกัน */}
            <Route
              path="/report/allInsurance"
              element={
                <ProtectedRoute>
                  <ReportAllInsurancePage />
                </ProtectedRoute>
              }
            />

            {/* รายงานแผนการออม */}
            <Route
              path="/report/savingplan"
              element={
                <ProtectedRoute>
                  <ReportSavingPage />
                </ProtectedRoute>
              }
            />

            {/* รายงานแผนการออม */}
            <Route
              path="/paymentpremiumcomplete"
              element={
                <ProtectedRoute>
                  <PaymentComplete />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </div>
        {window?.location?.pathname !== "/pdf" && <Footer />}
      </div>
    </React.Fragment>
  );
};
export default MainRouter;
